import { useRequiredContext } from "@redotech/react-util/context";
import CursorClickIcon from "@redotech/redo-icons/cursor-click-01.svg";
import CursorClickFilledIcon from "@redotech/redo-icons/cursor-click-01_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { ScheduleDemoButtonLocation } from "@redotech/redo-merchant-conversion-rpc/schema/analytics/send-schedule-demo-clicked-notification";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";
import { useConversionLockedAction } from "../../../../conversion/locked/use-conversion-locked-action";

export const PostPurchaseItems = memo(function PostPurchaseItems() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const { locked, onLockedClick } = useConversionLockedAction(
    ScheduleDemoButtonLocation.NAV_POST_PURCHASE_UPSELL,
  );

  return (
    <RedoSecondaryNavItem
      action={
        locked
          ? { type: "button", onClick: onLockedClick }
          : {
              type: "link",
              href: routes.getConversionSubRoute("post-purchase"),
            }
      }
      dimmed={locked}
      FilledIcon={CursorClickFilledIcon}
      friendlyName="Post-purchase upsell"
      id="post-purchase"
      isPrivate={locked}
      UnfilledIcon={CursorClickIcon}
    />
  );
});
